<template>
  <div>

    <m-filter-category302 @category="setupCategories" :category_column="categoryColumn"
                          :active-latest-filter="activeLatestFilter"
                          v-if="activeCategoryFilter"/>

    <div class="row product-slider-2">
      <div class="col product-slider-2-title text-right">
        <a href="javascript:void(0)" class="text-decoration-none">
          <span class="see-more-link">{{ title }}</span>
        </a>
      </div>
      <div class="col product-slider-2-show-more text-left">

        <router-link :to="{name:'Products',...productQuery()}"
                     class="text-decoration-none see-more-link">
              <span class="" v-t="`product.slider.more`">
          </span>
          <span>
          <m-icon icon="arrow-left" class="custom-icon-font-size "/>
        </span>


        </router-link>
      </div>
    </div>
    <m-product-wrapper :wait-for-category="waitForCategory"
                       :product-category-column="categoryColumn"
                       :product-categories="categories">
      <template v-slot="{products}">
        <swiper :navigation="true" :modules="modules" class="mySwiper" v-if="products.length > 0" ref="mySwiper"
                v-bind="swiperOptions">

          <swiper-slide v-if="showDefaultSlideItem">
            <slot></slot>
          </swiper-slide>

          <swiper-slide v-for="product in products" :key="product.id" class="">
            <m-product-card903 :showKeywords="showKeywords" :product-card-link="productCardLink" :product="product"
                               class="product-slider-2-card"/>
          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-prev" slot="button-prev"></div>
          <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
      </template>
    </m-product-wrapper>
  </div>
</template>

<script>
import mProductWrapper from "../../Wrappers/ProductWrapper";
import mIcon from '../../Icons/Icon'
import mProductCard903 from "../Card/ProductCard903";
import mFilterCategory302 from "../../Category/Filter/FilterCategory302";
// Import Swiper Vue.js components
import {Swiper, SwiperSlide} from "swiper/vue";
import {EffectFade} from 'swiper';
// Import Swiper styles
import "swiper/css";

import "swiper/css/navigation";
import 'swiper/css/effect-fade';

// import required modules
import {Navigation} from "swiper";
import {ProductSliderProps} from "./ProductSliderProps";


export default {
  name: "ProductSlider1",
  components: {mProductWrapper, Swiper, SwiperSlide, mProductCard903, mIcon, mFilterCategory302},
  setup() {
    return {
      modules: [Navigation, EffectFade],
    };
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 4,
        spaceBetween: 30,
        autoplay: {
          delay: 2000,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          dynamicBullets: true
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        breakpoints: {
          100: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            spaceBetween: 20
          },
          300: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20
          },
          500: {
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 20
          },
          600: {
            slidesPerView: 3,
            slidesPerGroup: 2,
            spaceBetween: 20
          },
          765: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 20
          },
          980: {
            slidesPerView: 5,
            slidesPerGroup: 3,
            spaceBetween: 20
          },
          1200: {
            slidesPerView: 6,
            slidesPerGroup: 5,
            spaceBetween: 20
          }
        }
      },
      categories: null
    };
  },
  props: {
    ...ProductSliderProps
  },

  methods: {
    setupCategories(categories) {
      if (this.waitForCategory) {
        this.categories = categories
      }
      return true
    },
    productQuery() {
      if (this.categories == null) {
        return {query: {}}
      }
      return {query: {category: this.categories.join(','), category_column: 'slug'}}
    }
  },
  mounted() {
    this.categories = this.productCategories
  }
};
</script>

<style>
@media only screen and (max-width: 500px) {
  .product-slider-2-card * {
    font-size: 13px;
  }
}
</style>

<style scoped>
.see-more-link {
  color: var(--primary);
  font-size: 19px;
  font-weight: bold;
}


</style>